/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Referral/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Kind from './Kind/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Referral({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/Referrals/Referral"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Referral.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-ZLvzN1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Kind
  viewPath={`${viewPath}/Kind`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
{children}
</React.Fragment>)
}